import { createContext } from 'react';

const BasketContext = createContext({
  show: true,
});

export default BasketContext;
